<template>
  <div class="contacts-box">
    <div class="c-title-line">
      <div class="c-title" style="width: 130px;">后续文件接收人信息</div>
      <div class="c-tip">
        提示：修改保存后，历史订单不会更新后续文件接收信息，如需更新，请重新提交订单审核。
      </div>
    </div>
    <div class="contact-edit-box">
      <div class="c-line">
        <!-- 联系人名称 -->
        <div class="c-row">
          <div class="c-title">
            <span class="c-title-dage">*</span>
            <span>联系人姓名</span>
          </div>
          <div class="c-input">
            <el-input
              v-model="applicant.extName"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <!-- 申请人地址 -->
        <div class="c-row">
          <div class="c-title">
            <span class="c-title-dage">*</span>
            <span>联系人地址</span>
          </div>
          <div class="c-input">
            <el-cascader
              v-model="addressCodes.addressDomestic"
              :props="props"
              :teleported="false"
              :options="millListChildren"
              style="width: 100%"
            />
          </div>
        </div>
      </div>
      <div class="c-line">
        <!-- 联系人详细地址 -->
        <div class="c-row">
          <div class="c-title">
            <span class="c-title-dage">*</span>
            <span>联系人详细地址</span>
          </div>
          <div class="c-input">
            <el-input
              v-model="applicant.extAddress"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <!-- 联系人邮箱 -->
        <div class="c-row">
          <div class="c-title">
            <span class="c-title-dage">*</span>
            <span>联系人邮箱</span>
          </div>
          <div class="c-input">
            <el-input
              v-model="applicant.domesticReceiverEmail"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="c-line">
        <!-- 联系人电话 -->
        <div class="c-row">
          <div class="c-title">
            <span class="c-title-dage">*</span>
            <span>联系人电话</span>
          </div>
          <div class="c-input">
            <el-input
              v-model="applicant.extTel"
              :oninput="
                (applicant.extTel = applicant.extTel.replace(/[^0-9]/g, ''))
              "
              maxlength="11"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <!-- 联系人邮编 -->
        <div class="c-row">
          <div class="c-title">
            <span class="c-title-dage">*</span>
            <span>联系人邮编</span>
          </div>
          <div class="c-input" style="position: relative">
            <el-input
              maxlength="6"
              v-model="applicant.extCode"
              :oninput="
                (applicant.extCode = applicant.extCode.replace(/[^0-9]/g, ''))
              "
              placeholder="请输入"
              @focus="millStateChange"
              @click.stop="() => {}"
            ></el-input>
            <PostCode
              :millList="millList"
              :millState="millState"
              v-if="millState"
              :alwaysLeft="true"
              :bookType="applicant.bookType"
              :applicantType="applicant.applicantType"
              :applicantDetailType="applicant.applicantDetailType"
              @codeStateChange="codeStateChange"
              @codeChange="codeChange"
            ></PostCode>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _validate from "@/framework/common/qds_validate";
import PostCode from "./postCode.vue";
export default {
  props: ["applicant", "millList", "millListChildren", "addressCodes"],
  components: {
    PostCode: PostCode,
  },
  data() {
    return {
      millState: false,
      props: {
        label: "name",
        value: "id",
        children: "children",
      },
    };
  },

  mounted() {},

  methods: {
    // 编辑申请主体联系人信息
    contactUpdate() {
      let params = {
        domesticReceiverEmail: this.applicant.domesticReceiverEmail,
        extAddress: this.applicant.extAddress,
        extCode: this.applicant.extCode,
        extName: this.applicant.extName,
        extTel: this.applicant.extTel,
      };
      this.$emit("applicantContactChange", params);
      console.log(params);
    },
    // 邮政编码监测
    codeChange(val) {
      this.applicant.extCode = val;
      this.millState = false;
    },
    // 邮编是否显示控制
    codeStateChange(state) {
      this.millState = state;
    },
    millStateChange() {
      let self = this;
      setTimeout(() => {
        self.millState = true;
      }, 300);
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
<style lang="less" scoped>
&:deep(.el-input__suffix) {
  right: 10px;
  top: 9px;
}

.c-title {
  width: 80px;
}

.active {
  color: #ff7200 !important;
}
</style>
